const NIP_WEIGHTS = [6, 5, 7, 2, 3, 4, 5, 6, 7] as const;

/**
 * Normalize a Polish NIP/VAT input into a 10-digit NIP.
 * Accepts optional "PL" prefix and separators.
 */
export function normalizeNip(value: string): string {
  const compact = value.trim().toUpperCase().replace(/^PL/, "");
  return compact.replace(/[^0-9]/g, "");
}

/**
 * Validate Polish NIP using checksum algorithm.
 */
export function isValidPolishNip(value: string): boolean {
  const nip = normalizeNip(value);
  if (!/^\d{10}$/.test(nip)) {
    return false;
  }

  const checksum = NIP_WEIGHTS.reduce((sum, weight, index) => {
    return sum + weight * Number(nip[index]);
  }, 0) % 11;

  if (checksum === 10) {
    return false;
  }

  return checksum === Number(nip[9]);
}
